import ExamImage from "../../components/ExamImage";
import CircleTextWidget from "./CircleText";

export default function StimulusCircleTextWidget({
  stimulus,
  content,
  value,
  onChange,
  mode,
  feedback
}) {
  const position = stimulus?.position ?? "below";
  const showFeedback = Boolean(feedback);

  return (
    <div className="stimulus-circle-text">
      {stimulus && position === "above" && (
        <StimulusRenderer stimulus={stimulus} />
      )}

      <div className="circle-text-body">
        <CircleTextWidget
          content={content}
          value={value}
          onChange={onChange}
          mode={showFeedback ? "review" : mode}
          feedback={feedback}
        />
      </div>

      {stimulus && position === "below" && (
        <StimulusRenderer stimulus={stimulus} />
      )}
    </div>
  );
}

/* ───────────────────────────────────────────── */

function StimulusRenderer({ stimulus }) {
  switch (stimulus.type) {
    case "image":
      return (
        <ExamImage
          src={stimulus.src}
          alt={stimulus.alt ?? ""}
          style={{
            maxWidth: stimulus.maxWidth ?? 480,
            marginBottom: 16,
            borderRadius: 8
          }}
        />
      );

    case "svg":
      return (
        <div
          style={{ marginBottom: 16 }}
          dangerouslySetInnerHTML={{ __html: stimulus.svg }}
        />
      );

    case "audio":
      return (
        <audio
          controls
          src={stimulus.src}
          style={{ marginBottom: 16 }}
        />
      );

    default:
      return null;
  }
}
